import { useState } from 'react';
import { createDiscount, updateDiscount } from '../../api/discounts.api';

export default function DiscountFormModal({ onClose, onSaved, data }) {
  const [form, setForm] = useState({
    code: data?.code || '',
    type: data?.type || 'percent',
    value: data?.value || '',
    global: data?.global ?? true,
    product: data?.product || '',
    expiresAt: data?.expiresAt ? data.expiresAt.substring(0, 10) : '',
  });

  const isEdit = !!data;

  const submit = async (e) => {
    e.preventDefault();

    const payload = {
      ...form,
      code: form.code.toUpperCase(),
      value: Number(form.value),
    };

    if (isEdit) await updateDiscount(data._id, payload);
    else await createDiscount(payload);

    onSaved();
  };

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center">
      <form
        onSubmit={submit}
        className="bg-white w-full max-w-md p-6 rounded-2xl shadow-xl">
        <h2 className="font-bold text-lg mb-4">
          {isEdit ? 'ویرایش کد تخفیف' : 'ایجاد کد جدید'}
        </h2>

        <div className="space-y-3">
          <input
            type="text"
            className="w-full border p-2 rounded-xl"
            placeholder="کد"
            value={form.code}
            onChange={(e) => setForm({ ...form, code: e.target.value })}
            required
          />

          <select
            className="w-full border p-2 rounded-xl"
            value={form.type}
            onChange={(e) => setForm({ ...form, type: e.target.value })}>
            <option value="percent">درصدی</option>
            <option value="amount">مبلغ ثابت</option>
          </select>

          <input
            type="number"
            className="w-full border p-2 rounded-xl"
            placeholder="مقدار"
            value={form.value}
            onChange={(e) => setForm({ ...form, value: e.target.value })}
            required
          />

          <label className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={form.global}
              onChange={(e) => setForm({ ...form, global: e.target.checked })}
            />
            اعمال برای تمام محصولات؟
          </label>

          {!form.global && (
            <input
              type="text"
              className="w-full border p-2 rounded-xl"
              placeholder="کد محصول"
              value={form.product}
              onChange={(e) => setForm({ ...form, product: e.target.value })}
            />
          )}

          <input
            type="date"
            className="w-full border p-2 rounded-xl"
            value={form.expiresAt}
            onChange={(e) => setForm({ ...form, expiresAt: e.target.value })}
          />
        </div>

        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-xl border">
            بستن
          </button>

          <button
            type="submit"
            className="px-4 py-2 rounded-xl bg-blue-600 text-white">
            ذخیره
          </button>
        </div>
      </form>
    </div>
  );
}
